/* Soothe Organic - Custom JS (vanilla, no jQuery) */

document.addEventListener('DOMContentLoaded', function() {

  /* ============================================
   * Swiper Carousels
   * ============================================ */
  if (typeof Swiper !== 'undefined') {
    // Product slider
    if (document.querySelector('.swiper-container')) {
      new Swiper('.swiper-container', {
        scrollbar: { el: '.swiper-scrollbar', draggable: true },
        breakpoints: {
          320:  { slidesPerView: 1 },
          641:  { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 56 }
        }
      });
    }

    // Highlight text bar
    if (document.querySelector('.highlight-text-bar')) {
      new Swiper('.highlight-text-bar', {
        slidesPerView: 1,
        autoplay: { delay: 5000, disableOnInteraction: false }
      });
    }

    // Featured blog slider
    if (document.querySelector('.feature_blog_slider')) {
      new Swiper('.feature_blog_slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: { el: '.swiper-scrollbar', draggable: true },
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 26 },
          990: { slidesPerView: 3, spaceBetween: 36 }
        }
      });
    }
  }

  /* ============================================
   * Menu positioning for dropdowns
   * ============================================ */
  function positionMenuDropdowns() {
    document.querySelectorAll('ul.list-menu.list-menu--inline li').forEach(function(li) {
      var submenu = li.querySelector('ul');
      if (submenu) {
        submenu.style.left = li.offsetLeft + 'px';
      }
    });
  }
  positionMenuDropdowns();
  window.addEventListener('resize', positionMenuDropdowns);

  /* ============================================
   * Add wrapper classes for content blocks
   * ============================================ */
  document.querySelectorAll('.text_block_wrap').forEach(function(el) {
    if (el.parentElement) el.parentElement.classList.add('text_block_wrapper');
  });
  document.querySelectorAll('.image_block_wrap').forEach(function(el) {
    if (el.parentElement) el.parentElement.classList.add('image_block_wrapper');
  });

  /* ============================================
   * Header menu active state
   * ============================================ */
  document.querySelectorAll('.header ul.list-menu li').forEach(function(li) {
    li.addEventListener('click', function() {
      document.querySelectorAll('.header ul.list-menu li').forEach(function(item) {
        item.classList.remove('is__active');
      });
      this.classList.add('is__active');
    });
  });

  /* ============================================
   * Tab switching
   * ============================================ */
  document.querySelectorAll('ul.tabs li').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var tabId = this.getAttribute('data-tab');
      document.querySelectorAll('ul.tabs li').forEach(function(t) { t.classList.remove('current'); });
      document.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('current'); });
      this.classList.add('current');
      var target = document.getElementById(tabId);
      if (target) target.classList.add('current');
    });
  });

  /* ============================================
   * Equal height matching (replaces matchHeight)
   * ============================================ */
  function matchHeights(selector) {
    var elements = document.querySelectorAll(selector);
    if (!elements.length) return;
    // Reset
    elements.forEach(function(el) { el.style.height = 'auto'; });
    var maxH = 0;
    elements.forEach(function(el) {
      var h = el.offsetHeight;
      if (h > maxH) maxH = h;
    });
    elements.forEach(function(el) { el.style.height = maxH + 'px'; });
  }

  function matchAllHeights() {
    matchHeights('.multicolumn-card__info .custom-html');
    matchHeights('.same-height');
    matchHeights('.same-tagline');
    matchHeights('.product-grid-container .card-wrapper .card__inner');
  }
  matchAllHeights();
  window.addEventListener('resize', matchAllHeights);

  /* ============================================
   * Tab drawer accordion (replaces slideUp/Down)
   * ============================================ */
  document.querySelectorAll('.tab_drawer_heading').forEach(function(heading) {
    heading.addEventListener('click', function() {
      if (this.classList.contains('d_active')) {
        this.nextElementSibling.style.maxHeight = null;
        this.classList.remove('d_active');
        this.nextElementSibling.classList.remove('active_content');
      } else {
        // Close siblings
        this.parentElement.querySelectorAll('.tab_drawer_heading').forEach(function(h) {
          h.classList.remove('d_active');
        });
        document.querySelectorAll('.tab-content').forEach(function(c) {
          c.style.maxHeight = null;
        });
        this.classList.add('d_active');
        var content = this.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* ============================================
   * FAQ accordion
   * ============================================ */
  document.querySelectorAll('.faq_drawer_heading').forEach(function(heading) {
    heading.addEventListener('click', function() {
      if (this.classList.contains('d_active')) {
        this.nextElementSibling.style.maxHeight = null;
        this.classList.remove('d_active');
        this.nextElementSibling.classList.remove('active_content');
      } else {
        var container = this.closest('.tab_container');
        if (container) {
          container.querySelectorAll('h6').forEach(function(h) { h.classList.remove('d_active'); });
        }
        this.classList.add('d_active');
        document.querySelectorAll('.radio_tab_content').forEach(function(c) {
          c.style.maxHeight = null;
        });
        var content = this.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* ============================================
   * Blog tab pagination (vanilla replacement)
   * ============================================ */
  function setupBlogPagination(tabId, containerSelector) {
    var container = document.querySelector(containerSelector);
    if (!container) return;
    var items = document.querySelectorAll('#' + tabId + ' .blog-articles__article');
    if (!items.length) return;
    var perPage = 6;
    items.forEach(function(item, i) {
      item.style.display = i < perPage ? '' : 'none';
    });
  }
  setupBlogPagination('tab-0', '#pagination-container0');

  /* ============================================
   * Mega menu hover
   * ============================================ */
  document.querySelectorAll('.mega-menu').forEach(function(menu) {
    menu.addEventListener('mouseenter', function() {
      document.querySelectorAll('.mega-menu').forEach(function(m) { m.removeAttribute('open'); });
      this.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', function() {
      document.querySelectorAll('.mega-menu').forEach(function(m) { m.removeAttribute('open'); });
    });
  });

  /* ============================================
   * Horizontal scrollbar for collection/blog menus
   * (CSS-based replacement for mCustomScrollbar)
   * ============================================ */
  document.querySelectorAll('.collection_menu_wrap.hide-desktop, .blog_menu_wrapper .tab_title_wrapper.hide-desktop').forEach(function(el) {
    el.style.overflowX = 'auto';
    el.style.webkitOverflowScrolling = 'touch';
    el.style.scrollbarWidth = 'thin';
  });

});
